/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Section_OverageInputs */



/**
* | output |
* | --- |
* | "Overage & Quotas" |
*
* @param {Faq_Section_OverageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const faq_section_overage = /** @type {((inputs?: Faq_Section_OverageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Section_OverageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Überverbrauch & Kontingente")
	return /** @type {LocalizedString} */ ("Overage & Quotas")
});